const locationMapping = {
    buenosaires: "Buenos Aires",
    sydney: "Sydney",
    vienna: "Vienna",
    jette: "Brussels (Jette)",
    brusselszaventem: "Brussels (Zaventem)",    
    blumenau: "Blumenau",
    barueri: "Barueri",
    varginha: "Varginha",
    mississauga: "Mississauga",
    beijing: "Beijing",
    guangzhou: "Guangzhou",
    shanghai: "Shanghai",
    shanghaizhangjiang: "Shanghai Zhang jiang",
    shenzhen: "Shenzhen",
    suzhou: "Suzhou",
    suzhougbs: "Suzhou GBS",
    hixquilucan:"Huixquilucan",
    zhuhai: "Zhuhai",
    santiago: "Santiago",
    bogota: "Bogota",
    copenhagen: "Copenhagen",
    cairo: "Cairo",
    espoo: "Espoo",
    suresnes: "Suresnes",
    haifa: "Haifa",
    bangalore: "Bangalore",
    chennaigbs: "Chennai GBS",
    gurgaon: "Gurgaon",
    kolkata: "Kolkata",
    chakanpune: "Pune (Chakan)",
    pimpripune: "Pune (Pimpri)",
    banerpune: "Pune (Baner)",
    batam: "Batam",
    genova: "Genova",
    milano: "Milano",
    tokyo: "Tokyo",
    seoul: "Seoul",
    penangkrystalpoint: "Penang (Krystal Point)",
    huixquilucan: "Huixquilucan",
    guadalajara: "Guadalajara",
    best: "Best",
    drachten: "Drachten",
    eindhoven: "Eindhoven",
    oslo: "Oslo",
    cidadedelpanama: "Panama City",
    lodz: "Lodz",
    warsaw: "Warsaw",
    sanjuan: "San Juan",
    bucharest: "Bucharest",
    riyadh: "Riyadh",
    singapore: "Singapore",
    johannesburg: "Johannesburg",
    madrid: "Madrid",
    stockholm: "Stockholm",
    istanbul: "Istanbul",
    dubai: "Dubai",
    farnborough: "Farnborough",
    plymouth: "Plymouth",
    murrysville: "Murrysville",
    bothell: "Bothell",
    pittsburgh: "Pittsburgh",
    cambridge: "Cambridge",
    nashville: "Nashville",
    coloradosprings: "Colorado Springs",
    hochiminhcity: "Ho Chi Minh City",
    malvern: "Malvern",
    paris: "Paris",
    prague: "Prague",
  };
  
  module.exports = locationMapping;
  